import { NavState } from '@/shared/types/app'

const CHAT_MESSAGING_NAV_STATES = new Set<NavState>([
  NavState.CHATS,
  NavState.CREATE_CHAT,
  NavState.CREATE_MODERATED_CHAT,
])

export const isChatMessagingNavState = (state: NavState): boolean =>
  CHAT_MESSAGING_NAV_STATES.has(state)
